import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../instance";
 
 
const initialState = {
  deleteloading: false,
};

export const deletePaybill = createAsyncThunk(
  "staffSettingSlice/deletePaybill",
  async (data) => {
    const res = await axiosInstance
      .delete(`/api/v1/payments/deletePaybill/${data?.pbId}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteTariff = createAsyncThunk(
  "staffSettingSlice/deleteTariff",
  async (data) => {
    const res = await axiosInstance
      .delete(`/api/v1/payments/deleteTariff/${data?.tarId}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteTariffNegotiated = createAsyncThunk(
  "staffSettingSlice/deleteTariffNegotiated",
  async (data) => {
    const res = await axiosInstance
      .delete(
        `/api/v1/payments/tariff-negotiated/deleteNegotiatedTariff/${data?.tarId}`
      )
      .then((res) => res.data);
    return res;
  }
);

export const deleteNotification = createAsyncThunk(
  "staffSettingSlice/deleteNotification",
  async (data) => {
    const res = await axiosInstance
      .delete(`/api/v1/notification/${data?.notId}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteReceipt = createAsyncThunk(
  "staffSettingSlice/deleteReceipt",
  async (data) => {
    const res = await axiosInstance
      .delete(`/api/v1/receipts/delete-manual-receipt/${data?.mrId}`)
      .then((res) => res.data);
    return res;
  }
);
export const deleteWhiteList = createAsyncThunk(
  "staffSettingSlice/deleteWhiteList",
  async (data) => {
    const res = await axiosInstance
      .delete(`/api/v1/payments/delete-account-whitelist/${data?.awId}`)
      .then((res) => res.data);
    return res;
  }
);
export const deleteSlice = createSlice({
  name: "delete",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(deletePaybill.pending, (state) => {
        state.deleteloading = true;
      })
      .addCase(deletePaybill.fulfilled, (state, action) => {
        state.deleteloading = false;
      })
      .addCase(deletePaybill.rejected, (state) => {
        state.deleteloading = false;
      })

      .addCase(deleteTariff.pending, (state) => {
        state.deleteloading = true;
      })
      .addCase(deleteTariff.fulfilled, (state, action) => {
        state.deleteloading = false;
      })
      .addCase(deleteTariff.rejected, (state) => {
        state.deleteloading = false;
      })

      .addCase(deleteTariffNegotiated.pending, (state) => {
        state.deleteloading = true;
      })
      .addCase(deleteTariffNegotiated.fulfilled, (state, action) => {
        state.deleteloading = false;
      })
      .addCase(deleteTariffNegotiated.rejected, (state) => {
        state.deleteloading = false;
      })

      .addCase(deleteNotification.pending, (state) => {
        state.deleteloading = true;
      })
      .addCase(deleteNotification.fulfilled, (state, action) => {
        state.deleteloading = false;
      })
      .addCase(deleteNotification.rejected, (state) => {
        state.deleteloading = false;
      })

      .addCase(deleteReceipt.pending, (state) => {
        state.deleteloading = true;
      })
      .addCase(deleteReceipt.fulfilled, (state, action) => {
        state.deleteloading = false;
      })
      .addCase(deleteReceipt.rejected, (state) => {
        state.deleteloading = false;
      })

      .addCase(deleteWhiteList.pending, (state) => {
        state.deleteloading = true;
      })
      .addCase(deleteWhiteList.fulfilled, (state, action) => {
        state.deleteloading = false;
      })
      .addCase(deleteWhiteList.rejected, (state) => {
        state.deleteloading = false;
      });
  },
});

export default deleteSlice.reducer;
export const {} = deleteSlice.actions;
